import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box, Tabs, Tab, Paper } from '@mui/material';
const RECEPTION_TABS = [
  { path: '', label: 'Overview' },
  { path: 'appointments', label: 'Programări' },
  { path: 'check-in', label: 'Check-in' },
  { path: 'patients', label: 'Pacienți' },
  { path: 'unmatched-lab-results', label: 'Rezultate nemapate' },
  { path: 'invoicing', label: 'Facturare' },
  { path: 'payments', label: 'Plăți' },
  { path: 'communications', label: 'Comunicări' },
  { path: 'reports', label: 'Rapoarte' },
  { path: 'settings', label: 'Setări' }
];

export default function ReceptionLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = '/reception';
  const match = location.pathname.match(/\/(?:receptie|reception)(?:\/(.*))?/);
  const pathname = (match?.[1] || '').replace(/\/$/, '') || '';
  const currentTab = pathname === 'overview' ? '' : pathname;

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={currentTab}
          onChange={(_, v) => navigate(v ? `${basePath}/${v}` : basePath)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {RECEPTION_TABS.map((tab) => (
            <Tab key={tab.path} value={tab.path} label={tab.label} />
          ))}
        </Tabs>
      </Paper>
      <Outlet />
    </Box>
  );
}
